module.exports = __webpack_public_path__ + "app/announcement/modals/modal-update-announcement-3_HGn3wc.html";